module.exports = __webpack_public_path__ + "a7d96f5a0da82476bb2ebad372a1bfba.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-96@2x.png
// module id = 547
// module chunks = 0